
import apiClient from './client'
import type { Tariff, TableType, SessionTariffOptions } from '../types'

export const fetchTariffs = async (): Promise<Tariff[]> => {
    const response = await apiClient.get('/tariffs')
    return response.data.data
}

export const fetchActiveTariffs = async (): Promise<Tariff[]> => {
    const response = await apiClient.get('/tariffs?active=true')
    return response.data.data
}

export const fetchActiveTariffsByType = async (): Promise<Record<TableType, Tariff[]>> => {
    const response = await apiClient.get('/tariffs/by-type')
    return response.data.data
}

export const fetchSessionTariffOptions = async (tableType: TableType): Promise<SessionTariffOptions> => {
    const response = await apiClient.get('/tariffs/session-options', {
        params: { tableType },
    })
    return response.data.data
}

export const getTariffById = async (tariffId: number): Promise<Tariff> => {
    const response = await apiClient.get(`/tariffs/${tariffId}`)
    return response.data.data
}

export const createTariff = async (tariff: Omit<Tariff, 'id'>): Promise<Tariff> => {
    const response = await apiClient.post('/tariffs', tariff)
    return response.data.data
}

export const updateTariff = async (
    tariffId: number,
    data: Partial<Tariff>
): Promise<void> => {
    const response = await apiClient.put(`/tariffs/${tariffId}`, data)
    return response.data.data
}

export const deleteTariff = async (tariffId: number): Promise<void> => {
    const response = await apiClient.delete(`/tariffs/${tariffId}`)
    return response.data.data
}

export const toggleTariffStatus = async (
    tariffId: number,
    isActive: boolean
): Promise<void> => {
    const response = await apiClient.patch(`/tariffs/${tariffId}/status`, { isActive })
    return response.data.data
}

export const calculateCost = async (
    tableType: TableType,
    durationMinutes: number,
    startTime?: string
): Promise<{ cost: number; appliedTariff: Tariff }> => {
    const response = await apiClient.post('/tariffs/calculate', {
        tableType,
        durationMinutes,
        startTime
    })
    return response.data.data
}